<div class="asistencia-barra">
  <div [style]="'width: ' + (percentage * 100 - (percentage === 1 ? 0 : 1)) +'%; background-color: ' + barColor + ';'">
    <label>{{percentageLabel}}% {{label}}</label></div>
</div>
